export const ROLES = {
	'Dance Instructor': 'instructor',
	'Dancer/Parent': 'dancer',
	'studio-owner': 'studio-owner'
};
